<template>
  <div
    class="sm:rounded-md p-5 shadow-lg border border-red text-center
              text-gray-600 font-medium text-wide" :class="{'bg-white' : customClass, 'bg-white' : customClass == null}"
  >
    <span v-if="message != null">{{ message }}</span>
    <span v-if="message == null">We're sorry to say we have come to the end of our LIVE 2020 worldwide User Group Meeting.
      The message/sharing option is currently disabled. To keep up to date with Vectric's activity, please visit your
      <a class="text-red underline" href="https://portal.vectric.com">V&Co</a> account, Vectric
      <a class="text-red underline" href="https://forum.vectric.com/">forum</a>
      or follow us on social media </span>
  </div>
</template>

<script>
export default {
  name: "DisabledActivity",
  props: {
    message: {
      type: String,
      required: false
    },
    customClass: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>

</style>
